import $ from 'jquery';
const $el = $('.js-products-showcase');

$el.on('mouseleave', (event) => {
	$(event.currentTarget).find('.eb-c-products-showcase__item').removeClass('is-visible');
});

$el.find('.eb-c-products-showcase__item').on('mouseenter', (event) => {
	$(event.currentTarget).addClass('is-visible');
});
